import type { ArmazenamentoLocal } from '../application/portas';
import type { Camera } from '../domain/camera';

const chaveCamera = (quadroUuid: string) => `nexital:camera:${quadroUuid}`;

/** localStorage pode estar indisponível (modo privado, bloqueio): falhas são ignoradas. */
export class ArmazenamentoNavegador implements ArmazenamentoLocal {
  lerCamera(quadroUuid: string): Camera | null {
    try {
      const valor = JSON.parse(localStorage.getItem(chaveCamera(quadroUuid)) ?? 'null');
      return valor && [valor.x, valor.y, valor.zoom].every(Number.isFinite) ? valor : null;
    } catch {
      return null;
    }
  }

  salvarCamera(quadroUuid: string, camera: Camera) {
    try {
      localStorage.setItem(chaveCamera(quadroUuid), JSON.stringify(camera));
    } catch {
      // sem armazenamento: a câmera volta ao enquadramento padrão na próxima visita
    }
  }
}
